<!--suppress AngularNgOptimizedImage, JSUnresolvedReference, HtmlUnknownTarget -->
<div class="dashboard-container">
  <div
    class="d-flex w-100 align-items-center justify-content-center flex-column mb-4">
    <div class="logo">
      <img src="assets/logos/logo-full.svg" alt="logo" />
    </div>
    @if (luser | async; as user) {
      <div class="welcome">
        <span class="fw-lighter text-secondary" i18n>Welcome</span>
        <span class="fw-light text-primary">
          @if (user.lastname || user.firstname) {
            {{ user.lastname }} {{ user.firstname }}
          } @else {
            {{ user.email }}
          }
        </span>
      </div>
    }
  </div>

  <!-- System Status Section -->
  <div class="container-fluid">
    <app-dashboard-logs-status></app-dashboard-logs-status>
  </div>
</div>
